import CodigoCtbInfracaoTransito from "./CodigoCtbInfracaoTransito";

class VigenciaCodigoInfracao {
    constructor(
        {
            id = null,
            codigo_ctb_infracao_transito_id = null,
            data_inicio_vigencia = null,
            data_fim_vigencia = null,
            valor_infracao = null,
            pontuacao = null,
            ind_compativel_fiscaliz_eletronica = null,
            ind_advertencia_escrito = null,
            created_at = null,
            updated_at = null,
            deleted_at = null,
            usuario_id = null,

            //ORM
            codigo_ctb_infracao_transito = {},
        } = {}
    ) {
        this.id = id;
        this.codigo_ctb_infracao_transito_id = codigo_ctb_infracao_transito_id;
        this.data_inicio_vigencia = data_inicio_vigencia;
        this.data_fim_vigencia = data_fim_vigencia;
        this.valor_infracao = valor_infracao;
        this.pontuacao = pontuacao;
        this.ind_advertencia_escrito = ind_advertencia_escrito;
        this.ind_compativel_fiscaliz_eletronica = ind_compativel_fiscaliz_eletronica;
        this.created_at = created_at;
        this.updated_at = updated_at;
        this.deleted_at = deleted_at;
        this.usuario_id = usuario_id;

        //ORM
        this.codigo_ctb_infracao_transito = codigo_ctb_infracao_transito ? new CodigoCtbInfracaoTransito(codigo_ctb_infracao_transito) : new CodigoCtbInfracaoTransito() ;

    }
}

export default VigenciaCodigoInfracao;